import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import useAuth from './hooks/useAuth';
import InternLayout from './components/layout/InternLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AvailableJobsPage from './pages/AvailableJobsPage';
import MyBookingsPage from './pages/MyBookingsPage';
import AssessmentPage from './pages/AssessmentPage';
import AssessmentTestPage from './pages/AssessmentTestPage';
import AvailabilityPage from './pages/AvailabilityPage';
import EarningsPage from './pages/EarningsPage';
import ReferralsPage from './pages/ReferralsPage';
import ProfilePage from './pages/ProfilePage';
import StripeOnboardingPage from './pages/StripeOnboardingPage';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isIntern, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated || !isIntern) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated, isIntern, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated && isIntern) {
    return <Navigate to="/" replace />;
  }

  return children;
}

const routes = [
  { path: '/', element: <DashboardPage /> },
  { path: '/jobs', element: <AvailableJobsPage /> },
  { path: '/bookings', element: <MyBookingsPage /> },
  { path: '/bookings/:bookingId/assess', element: <AssessmentPage /> },
  { path: '/onboarding-test', element: <AssessmentTestPage /> },
  { path: '/availability', element: <AvailabilityPage /> },
  { path: '/earnings', element: <EarningsPage /> },
  { path: '/referrals', element: <ReferralsPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/payouts/setup', element: <StripeOnboardingPage /> },
];

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      {routes.map((r) => (
        <Route
          key={r.path}
          path={r.path}
          element={
            <ProtectedRoute>
              <InternLayout>{r.element}</InternLayout>
            </ProtectedRoute>
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
